import { render, staticRenderFns } from "./cenJane.vue?vue&type=template&id=06c3e618&scoped=true&"
import script from "./cenJane.vue?vue&type=script&lang=js&"
export * from "./cenJane.vue?vue&type=script&lang=js&"
import style0 from "./cenJane.vue?vue&type=style&index=0&id=06c3e618&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c3e618",
  null
  
)

export default component.exports